import { field, form } from "svelte-forms";
import { required } from "svelte-forms/validators";
const carModel = field("carModel", "", [required()]);
const carMake = field("carMake", "", [required()]);
const carType = field("carType", "", [required()]);
function resetFields() {
    carMake.reset();
    carModel.reset();
    carType.reset();
}
const vehicleMakeForm = form(carMake, carModel, carType);
export { vehicleMakeForm, carMake, carModel, carType, resetFields };
